import React, {useEffect, useRef, useState} from 'react';
import styles from './ModalFade.module.css';

export const MODAL_FADE_OUT_MS = 140;

export const useModalFade = (shown: boolean) => {
  const [rendered, setRendered] = useState(shown);
  const [closing, setClosing] = useState(false);
  const renderedRef = useRef(shown);

  renderedRef.current = rendered;

  useEffect(() => {
    if (shown) {
      setRendered(true);
      setClosing(false);
      return;
    }
    if (!renderedRef.current) return;
    setClosing(true);
    const timeout = setTimeout(() => {
      setRendered(false);
      setClosing(false);
    }, MODAL_FADE_OUT_MS);
    return () => clearTimeout(timeout);
  }, [shown]);

  return {rendered, closing};
};

interface Props {
  closing: boolean;
  children: React.ReactNode;
}

const ModalFade = React.memo(({closing, children}: Props) => (
  <div className={`${styles.fade} ${closing ? styles.closing : ''}`}>
    {children}
  </div>
));

export default ModalFade;
